<template>
  <div style="margin-top: 20px">
    <el-form :model="formData" :rules="formRules" ref="formRef" size="mini" label-width="120px">
      <el-form-item label="名称" prop="name" :error="errMsg.name" style="width: 320px">
        <el-input v-model="formData.name"> </el-input>
      </el-form-item>
      <el-form-item label="权限">
        <el-tree ref="tree" :data="perList" show-checkbox node-key="id" :default-expanded-keys="expandedkeys" :default-checked-keys="checkedkeys" :props="defaultProps" empty-text=""> </el-tree>
      </el-form-item>
    </el-form>
    <div class="form-but">
      <el-button type="success" @click="roleSave">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'roleSave',
  created() {
    this.getPermissions()
  },
  data() {
    return {
      errMsg: {},
      formData: { id: 0, name: '', permissions: '' },
      perList: [],
      expandedkeys: [],
      checkedkeys: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 表单验证规则
      formRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    rest() {
      this.formData = { id: 0, name: '', permissions: '' }
      this.$refs.tree.setCheckedKeys([]) //清空勾选
      this.$refs.formRef.clearValidate()
    },
    //获取权限列表
    async getPermissions() {
      await this.$api.auth.permissionsList().then(res => {
        if (res.code != 200) return
        this.perList = res.data ? res.data : []
      })
    },
    //获取选中树型
    handleSubmit() {
      // getCheckedKeys 若节点可被选择（即 show-checkbox 为 true），则返回目前被选中的节点的 key 所组成的数组。
      // (leafOnly) 接收一个 boolean 类型的参数，若为 true 则仅返回被选中的叶子节点的 keys，默认值为 false
      // var parentIds = this.$refs.tree.getHalfCheckedKeys()
      var childsIds = this.$refs.tree.getCheckedKeys(true)
      // 利用set没有重复的值这一特性, 实现数组去重。Array.from方法可以将 Set 结构转为数组。
      this.formData.permissions = JSON.stringify(Array.from(new Set(childsIds)))
    },
    //保存
    async roleSave() {
      this.handleSubmit()
      this.$refs.formRef.validate(async vaild => {
        if (vaild) {
          this.initErrMsg()
          await this.$api.auth.roleSave(this.formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              if (this.formData.id == 0) {
                this.formData = { id: 0, name: '' }
              }
              this.$emit('callMethod')
            } else {
              for (let k in res.data) {
                this.errMsg[k] = res.data[k]
              }
            }
          })
        }
      })
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {}
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '')
      })
    },
    //父页面传数据
    setData(data) {
      this.$refs.tree.setCheckedKeys([]) //清空勾选
      if (data == undefined) {
        this.formData = { id: 0, name: '' }
      } else {
        this.formData = { id: data.id, name: data.name }
        this.checkedkeys = data.permissions ? JSON.parse(data.permissions) : []
      }
      this.initErrMsg()
      this.$refs.formRef.clearValidate()
    }
  }
}
</script>
